import React from 'react';
import Modal from './index';
import classes from './Modal.module.scss';
import ButtonSecondary from '../UI/ButtonSecondary';

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  children,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  isLoading = false,
}) => {
  if (!isOpen) return null;

  return (
    <Modal modalClose={onClose}>
      <div>
        {title && <h3>{title}</h3>}
        <div className={classes.Text}>{children}</div>

        <span
          onClick={isLoading ? null : onConfirm}
          className={`${classes.ConfirmButton} button-primary`}
        >
          {isLoading ? '...' : confirmLabel}
        </span>
        <ButtonSecondary
          onClick={onClose}
          value={cancelLabel}
          customClass={classes.CancelButton}
        />
      </div>
    </Modal>
  );
};

export default ConfirmModal;
